var _path, _path2, _g, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1021 14.5181H10.0383C8.67528 14.5181 7.57031 15.623 7.57031 16.9861V18.8425V25.6705V27.9821C7.57031 29.3451 8.67528 30.4501 10.0383 30.4501H25.1021C26.4651 30.4501 27.5701 29.3451 27.5701 27.9821V25.7044V25.6705V18.8425V16.9861C27.5701 15.623 26.4651 14.5181 25.1021 14.5181Z",
    fill: "url(#paint0_linear_1197_10992)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2474 14.7767V11.3215C23.2474 8.18645 20.706 5.64502 17.571 5.64502V5.64502C14.436 5.64502 11.8945 8.18645 11.8945 11.3215V14.7767",
    stroke: "url(#paint1_linear_1197_10992)",
    strokeWidth: 1.35592
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1197_10992)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.99609,
    y: 18.2947,
    width: 27.1482,
    height: 7.89767,
    rx: 2.46802,
    fill: "url(#paint2_linear_1197_10992)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.06389,
    y: 18.3625,
    width: 27.0126,
    height: 7.76208,
    rx: 2.40023,
    stroke: "white",
    strokeWidth: 0.135592
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54102 21.5159L12.4767 23.2108",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54102 23.2107L12.4767 21.5158",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0098 20.6682L11.0098 24.058",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8672 21.5159L18.8028 23.2108",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8672 23.2107L18.8028 21.5158",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3359 20.6682L17.3359 24.058",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1914 21.5159L25.1271 23.2108",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1914 23.2107L25.1271 21.5158",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6602 20.6682L23.6602 24.058",
    stroke: "white",
    strokeWidth: 0.79417,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1197_10992",
    x: 3.99609,
    y: 18.2947,
    width: 27.1484,
    height: 9.25362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.35592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.677959
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1197_10992"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_10992",
    x1: 9.09572,
    y1: 14.518,
    x2: 27.0616,
    y2: 29.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_10992",
    x1: 17.571,
    y1: 5.64502,
    x2: 17.571,
    y2: 14.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3935E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1197_10992",
    x1: 5.58733,
    y1: 18.9072,
    x2: 17.5702,
    y2: 26.1923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C183FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon9);
export default __webpack_public_path__ + "static/media/drive_card_icon9.1f8f8b6fe1b3c403a8025ea5be3231d3.svg";
export { ForwardRef as ReactComponent };